import React, { useEffect, useState } from "react";
import { fetchBuildInfo } from "../../services/build";

const BuildInfo = () => {
  const [info, setInfo] = useState({});
  let isMounted = false;

  useEffect(() => {
    isMounted = true;
    const getBuild = async () => {
      try {
        const build = await fetchBuildInfo();
        if (isMounted) {
          setInfo(build);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getBuild();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <strong>
      Version: {info.version} , AutoBuildNumber: {info.autoBuild}
    </strong>
  );
};

export default BuildInfo;
